




























import { currencies } from "@/json/config.json";
import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import Select from "@/components/basic/fields/Select.vue";
import Popup from "@/components/basic/Popup.vue";
import Vue from "vue";
import {UtilityHelper} from "@/helpers/UtilityHelper";
import i18n from "@/i18n";

export default Vue.extend({
  name: "currency",
  data() {
    return {
      country: "" as string,
      formData: {
        currencyChoice: "" as string,
      },
      TRANSLATION_KEY: "steps.Currency",
    };
  },
  computed: {
    currencies() {
      const language = i18n.locale.toUpperCase();
      if(language === "PL") {
;        return currencies.filter((currency) => currency.value !== "CZK");
      }
      return currencies;
    },
  },
  components: {
    Popup,
    Select,
    SubmitButton,
  },
});
